import React, { useState, createContext, useContext, useCallback } from 'react';
import PropTypes from 'prop-types';

import Modal from './boneyard/Modal';

export const ModalContext = createContext();
export const useModal = () => useContext(ModalContext);

const ModalProvider = props => {
  const [showModal, setShowModal] = useState(false);
  const [logo, setLogo] = useState();
  const [title, setTitle] = useState();
  const [content, setContent] = useState();
  const [isMobile, setIsMobile] = useState(false);
  const [modalOptions, setModalOptions] = useState();
  const [automationHook, setAutomationHook] = useState();
  const [isModalAutoClosed, setIsModalAutoClosed] = useState(true);

  const unSetModal = useCallback(() => {
    setIsModalAutoClosed(false);
    setShowModal(false);
    setTitle();
    setContent();
    setModalOptions();
    setAutomationHook();
    setLogo();
  }, [
    setShowModal,
    setTitle,
    setContent,
    setModalOptions,
    setAutomationHook,
    setLogo,
    setIsModalAutoClosed,
  ]);

  return (
    <ModalContext.Provider
      value={{
        unSetModal,
        setShowModal,
        setLogo,
        setTitle,
        setContent,
        setIsMobile,
        setModalOptions,
        setAutomationHook,
        isModalAutoClosed,
        setIsModalAutoClosed,
      }}
    >
      {props.children}
      {showModal && (
        <Modal
          showModal={showModal}
          logo={logo}
          title={title}
          unSetModal={unSetModal}
          isMobile={isMobile}
          options={modalOptions}
          automationHook={automationHook}
        >
          {content}
        </Modal>
      )}
    </ModalContext.Provider>
  );
};

ModalProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ModalProvider;
